import { createContext, use } from 'react';

import type { CosmosControls } from '@/core/CosmosControls';

/** En attente du premier rendu, en marche, ou écarté (version fixe). */
export type CosmosStatus = 'pending' | 'ready' | 'off';

export interface CosmosState {
  readonly status: CosmosStatus;
  /** Vrai dès que le décor affiche sa première image : les affiches fixes peuvent s'effacer. */
  readonly ready: boolean;
  /** Commandes du décor, ou `null` tant qu'il ne tourne pas. */
  readonly controls: CosmosControls | null;
}

/** État du décor cosmique. React 19 : le contexte sert directement de fournisseur. */
export const CosmosContext = createContext<CosmosState>({
  status: 'off',
  ready: false,
  controls: null,
});

export function useCosmos(): CosmosState {
  return use(CosmosContext);
}
